import { MdDeleteForever } from "react-icons/md"; 
import { AiOutlineEdit } from "react-icons/ai"; 

export const ShowTask = ({edit, setEdit, task, setTask, tasklist, setTasklist}) => {

    const handleDelete = (id) => {
        setTasklist(tasklist.filter((task) => task.id !== id));
        localStorage.setItem('tasklist', JSON.stringify(tasklist.filter((task) => task.id !== id)));
        
    };

    const handleEdit = (id) => {
        setEdit(true);
        const findTask = tasklist.find((task) => task.id === id);
        setTask(findTask);

       
      
    }

    
  return (

    <>
    <div className="flex justify-between items-center p-4 bg-gray-100 text-black w-full rounded-full">
        <span>Todos ({tasklist.length})</span>
        <span><button onClick={()=> setTasklist([])} className="rounded-lg bg-red-800 text-white px-4 py-2">Clear All</button></span>

    </div>

    <div className="flex flex-col md:flex-row w-full justify-center items-center flex-wrap">

        {tasklist.map((todo) => (
            <>
            <div key={todo.id} className="relative bg-gray-400 m-1 p-2 rounded-lg w-full md:w-1/4 md:m-1 md:p-1 ">
            <h3 className="text-xl font-bold">{todo.name}</h3>
            <p>{todo.date}</p>
            <div className="absolute flex justify-end items-center top-1 right-2">
            <span onClick={()=> handleEdit(todo.id)} className="m-4 text-blue-100 cursor-pointer"><AiOutlineEdit size="20px" /></span>
            <span onClick={()=> handleDelete(todo.id)} className="m-4 text-red-500 cursor-pointer"><MdDeleteForever size="20px" /></span>
            </div>
        </div>
          </>
        ))}
        
    </div>
    </>
  )
}
